import React from 'react';

const VARIANTS = ['success', 'info', 'warning', 'danger'];

/**
 * Inline alert box. variant mirrors react-bootstrap's Alert bsStyle values.
 *
 * @param {object} props
 * @param {'success'|'info'|'warning'|'danger'} [props.variant='info']
 *   Unknown values fall back to info.
 * @param {() => void} [props.onDismiss] When given, renders the × button;
 *   hiding the alert stays the caller's job.
 */
const Alert = ({ variant = 'info', onDismiss, className, children, ...rest }) => {
  const classes = [
    'ui-alert',
    `ui-alert--${VARIANTS.includes(variant) ? variant : 'info'}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div role="alert" className={classes} {...rest}>
      {onDismiss && (
        <button type="button" className="ui-alert__dismiss" aria-label="Close alert" onClick={onDismiss}>
          <span aria-hidden="true">&times;</span>
        </button>
      )}
      {children}
    </div>
  );
};

export default Alert;
